import React from "react";
import { CheckCircle2, Zap, Shield, BarChart3 } from "lucide-react";
import logo from "../logo.png";

const features = [
  { icon: Zap, text: "Bulk WhatsApp campaigns in seconds" },
  { icon: Shield, text: "Secure & Meta-verified API" },
  { icon: BarChart3, text: "Real-time delivery analytics" },
  { icon: CheckCircle2, text: "Template approval automation" },
];

const AuthLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen font-sans">
      {/* Left brand panel */}
      <div className="hidden lg:flex lg:w-[52%] flex-col justify-between bg-gradient-to-br from-brand-700 via-brand-600 to-brand-500 p-12 relative overflow-hidden">
        {/* decorative circles */}
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-white/5" />
        <div className="absolute -bottom-32 -right-20 h-[28rem] w-[28rem] rounded-full bg-white/5" />
        <div className="absolute top-1/2 left-1/2 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/[0.03]" />

        {/* Logo */}
        <div className="relative flex items-center gap-3">
          <img src={logo} alt="WhatsSend" className="h-10 w-10 rounded-xl object-contain" />
          <span className="text-xl font-bold text-white tracking-tight">WhatsSend</span>
        </div>

        {/* Hero text */}
        <div className="relative space-y-8">
          <div>
            <h1 className="text-4xl font-bold text-white leading-tight">
              Reach customers<br />where they are.
            </h1>
            <p className="mt-4 text-brand-100 text-base leading-relaxed max-w-sm">
              Send personalized WhatsApp messages at scale. Automate campaigns, track results, grow faster.
            </p>
          </div>

          <ul className="space-y-3">
            {features.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-center gap-3">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white/15">
                  <Icon className="h-3.5 w-3.5 text-white" />
                </span>
                <span className="text-sm text-brand-50">{text}</span>
              </li>
            ))}
          </ul>

          {/* Social proof */}
          <div className="flex items-center gap-4 pt-2">
            <div className="flex -space-x-2">
              {["A","B","C","D"].map((l) => (
                <span key={l} className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-brand-600 bg-white/20 text-xs font-semibold text-white">{l}</span>
              ))}
            </div>
            <p className="text-sm text-brand-100"><span className="font-semibold text-white">2,400+</span> businesses trust WhatsSend</p>
          </div>
        </div>

        <p className="relative text-xs text-brand-200">© {new Date().getFullYear()} WhatsSend. All rights reserved.</p>
      </div>

      {/* Right form panel */}
      <div className="flex flex-1 flex-col items-center justify-center bg-slate-50/70 dark:bg-[#0b0f17] px-6 py-12">
        {/* Mobile logo */}
        <div className="mb-8 flex items-center gap-2 lg:hidden">
          <img src={logo} alt="WhatsSend" className="h-9 w-9 rounded-xl object-contain" />
          <span className="text-lg font-bold text-slate-900 dark:text-white">WhatsSend</span>
        </div>

        <div className="w-full max-w-[440px]">
          <div className="rounded-3xl border border-slate-100 dark:border-ink-800 bg-white dark:bg-ink-900 p-8 sm:p-9 shadow-[0_4px_20px_rgba(0,0,0,0.06)] dark:shadow-2xl">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
